import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { ITargetRange } from "../ITargetRange";
import { BaseCareElementConfig } from "./BaseCareElementConfig";
import { CareElementType } from "./CareElementType";

class LabResultsCareElementConfig extends BaseCareElementConfig {
    public readonly CareElementType: CareElementType.LabResults;
    public StandardCode?: string;
    public Frequency?: CareElementFrequencyType;
    public TargetRange?: ITargetRange;
    public Operator?: CareElementOperatorType;
    public Unit?: string;

    public constructor(init: Omit<NonFunctionProperties<LabResultsCareElementConfig>, "CareElementType">) {
        super({ ...init, CareElementType: CareElementType.LabResults });
        Object.assign(this, init);
    }
}

export { LabResultsCareElementConfig };
